import styled from "styled-components";

const Content = styled.div` 
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 250px;
`

export default Content;